import clsx from 'clsx';
import { ReactComponent as Lightbulb } from 'patientOnboarding/assets/svg/lightbulb-line.svg';
import { FC } from 'react';

import { ModalToast } from 'lifestance-ui';

import { useInvoca, useResizingMediaQuery } from 'patientOnboarding/hooks';

import { defaultPhoneNumber, formatContactNumber, stateAbbrToName } from 'patientOnboarding/utils';

import styles from './PleaseCallModal.module.scss';

interface iPleaseCall {
  onClose: () => void;
  state: string;
  contactNumber?: string;
}

const PleaseCallModal: FC<iPleaseCall> = ({ onClose, state, contactNumber = '' }) => {
  const isMobile = useResizingMediaQuery('(max-width: 768px)');
  useInvoca();

  return (
    <ModalToast onClose={onClose}>
      <div className={styles.icon}>
        <Lightbulb />
      </div>
      <h1 className={styles.title}>
        Please call to book
        {!isMobile ? <br /> : ' '}
      </h1>
      <span className={styles.description}>
        We can’t currently accommodate online booking in&nbsp;
        {stateAbbrToName(state)}
        . To find a provider and finish booking, please call&nbsp;
        {isMobile ? (
          <a
            className={clsx(styles.phoneNumber, 'invocaPhoneNumber')}
            href={`tel:${formatContactNumber(contactNumber)}`}
          >
            {contactNumber || defaultPhoneNumber}
          </a>
        ) : (
          <>
            &nbsp;
            <span className={clsx(styles.phone, 'invocaPhoneNumber')}>
              {contactNumber || defaultPhoneNumber}
            </span>
          </>
        )}
      </span>
    </ModalToast>
  );
};

export default PleaseCallModal;
